<div class="error-state container-expanded">
    <div class="container">
        <div class="flex-column flex-md-row ">
            <div class="col-12 col-md-6">
                <div class="errors-intro ">
                    <ng-container *ngIf="title; else titleDefault">
                        <h3 class="mat-text-primary mb-0">{{ title }}</h3>
                    </ng-container>
                    <ng-template #titleDefault>
                        <h3 class="mat-text-primary mb-0">Analisi non disponibile</h3>
                        <!-- <button mat-flat-button  color="primary" (click)="goContactAssistance()" class="p--24 mb--24">
                            <h5 class="m--0">Contatta subito un consulente</h5>
                        </button> -->
                    </ng-template>
                    <ng-container *ngIf="message">
                        <p>{{ message }}</p>
                    </ng-container>
                    <!-- <ng-template #messageDefault>
                        <p>Si è verificato un errore temporaneo. Per favore riprova più tardi.</p>
                    </ng-template> -->
                    <ng-container *ngIf="errors && errors.length">
                        <p>L’intelligenza artificiale di Delfi.ai non può completare la richiesta di calcolo a causa
                            delle
                            seguenti
                            condizioni:</p>
                        <ol class="errors-list">
                            <li *ngFor="let error of errors">{{error}}</li>
                        </ol>
                    </ng-container>
                </div>
                <div class="section-error">
                    <!-- <div class="d-flex gap-8 align-items-center">

                        <mat-icon class="icon-warn" color="warn">warning_amber</mat-icon>
                        <h5>Alcuni dati non sono attualmente disponibili</h5>
                    </div> -->
                    <div class="mb--24">
                        <div>Ci scusiamo per l'inconveniente, ma al momento non riusciamo a recuperare tutti i dati finanziari necessari alla generazione del Benchmark.
                        </div>
                        <div>Tuttavia, i nostri consulenti esperti sono a tua disposizione per offrirti supporto e consulenza personalizzata. <b>Puoi richiedere:</b></div>
                        <ul class="list-check-primary">
                            <li><b>Un piano personalizzato per la tua azienda</b></li>
                            <li><b>Obiettivi di crescita e un piano strategico</b></li>
                            <li><b>L'accesso ai prodotti in free trial per 30 giorni</b></li>
                            <li><b>Una gamma di prodotti e servizi per innovare la tua PMI</b></li>
                            <!-- <li><b>Comprendere la tua situazione finanziaria attuale</b></li>
                            <li><b>Identificare le aree di miglioramento</b></li>
                            <li><b>Definire obiettivi di crescita realistici</b></li>
                            <li><b>Sviluppare una strategia per raggiungerli</b></li> -->
                        </ul>
                    </div>
                    <div class="mt--24 mb--16 fw-bold">
                        <!-- Ti abbiamo inviato una mail per completare la registrazione ed attivare il tuo account gratuito.<br/>Potrai accedere al Marketplace e scoprire i nostri servizi e prodotti per <b>incrementare la tua produttività ed ottenere benefici fiscali</b>. -->
                        Controlla la tua mail e completa la registrazione per entrare nel <span class="text-primary">Marketplace</span> di Delfi.ai.
                    </div>
                    <div class="d-flex flex-lg-row flex-column gap-24 align-items-center mt--24 mb--24">
                        oppure 
                    <ng-container *ngIf="company && piva; else openChat">
                        <app-component-identity-report [company]="company" [piva]="piva" [buttononly]="true"
                            [buttonlabel]="buttonlabelchat"></app-component-identity-report>
                    </ng-container>
                    <ng-template #openChat>
                        <button mat-stroked-button  color="primary" (click)="goContactAssistance()" class="fs-18">
                            <b>Contatta un consulente</b>
                            <span class="di di-chat"></span>
                        </button>
                    </ng-template>
                    
                    <!-- <button mat-stroked-button color="primary" (click)="goToMarketplace()" class="p--24"><b>Entra nel marketplace</b> <span class="di di-arrow-right"></span></button> -->
                    </div>
                    <!-- <h5 class="final-cta mt--24"><strong>Insieme possiamo aiutarti a far crescere la tua azienda.</strong>
                    </h5> -->

                    <!-- <ul class="list-circle-primary">
                    <li>Ditte individuali</li>
                    <li>Enti pubblici</li>
                    <li>Nuove aziende<br><small>senza un bilancio consolidato o depositato.</small></li>

                </ul> -->
                    <!-- <p>Se la tua partita IVA rientra in una di queste categorie, possiamo offrirti forme alternative di
                    supporto e consulenza personalizzati ,per aiutarti a raggiungere i tuoi obiettivi di crescita.</p> -->


                </div>
                <!-- <div class="errors-actions" *ngIf="actions && actions.length">
                <button mat-flat-button color="primary" (click)="goToMarketplace()">Entra nel marketplace <span
                        name="m-arrow-right"></span></button>
            </div> -->
            </div>

        </div>
    </div>

</div>